module.exports = __webpack_public_path__ + "img/moyapay_primary.9e9ffc82.png";